import { useEffect, useState } from "react";
import validator from "@rjsf/validator-ajv6";
import { Form } from "@rjsf/mui";
import { useTranslation } from "react-i18next";
import InfiniteTable from "../pages/InfiniteTable";
import { StyledDataGrid } from "../pages/StyledDataGrid";
import { useDispatch, useSelector } from "react-redux";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import { IwdAuthWrapper } from "../utils/IwdAuthWrapper";
import DraftsIcon from "@mui/icons-material/Drafts";
import ModalDialog from "./meters/ModalDialog";
import SingleDatePicker from "./form/formComponents/SingleDatePicker";
import { useNavigate } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import { Link } from "react-router-dom";
import { store } from "../redux/store";
import ExportReadingsButton from "./ExportReadingsButton";
import theme from "../theme";
import { setAllReadingsRecors } from "../redux/slices/meterSlice";
import { setBreadCrumbs } from "../redux/slices/breadCrumbMeterSlice";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ErrorIcon from "@mui/icons-material/Error";
import IwdDataGrid from "../pages/IwdDataGrid";
import { useSearchParams } from "react-router-dom";
/* import { useLazyGetAllReadingsQuery } from "../../redux/slices/meterApi"; */
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";
const AllLastReadings = () => {
  const readings = useSelector((state) => state?.meterSlice?.allReadings);
  const dispatch = useDispatch();
  const [modalMessage, setModalMessage] = useState(false);
  const [message, setMessage] = useState(null);
  const allReadingsCount = useSelector(
    (state) => state?.meterSlice?.allReadingsCount
  );
  const haveRecords = useSelector((state) => state?.meterSlice?.haveRecords);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [refreshParams, setRefreshParams] = useState(false);
  let [searchParams, setSearchParams] = useSearchParams();
  const [getReadings] = store.useLazyGetAllReadingsQuery();
  const [formData, setFormData] = useState({});
  const now = new Date();
  const toDate = new Date(
    Date.UTC(now.getFullYear(), now.getMonth(), now.getDate() + 1)
  );
  const paramsList = {
    page: page,
    per_page: perPage,
    /*  no_gateway: true, */
    most_recent_2: true,
    message_type: "reading",
    to_date: formData?.to_date ?? now.toISOString(),
  };

  const schema = {
    type: "object",
    properties: {
      to_date: {
        $id: "3",
        title: t("inserted_at"),
        type: "string",
        default: paramsList.to_date ?? "",
        label: t("end_date"),
      },
    },
  };
  const uiSchema = {
    "ui:submitButtonOptions": {
      submitText: t("search"),
      props: {
        className: "bntListSearch",
        variant: window?.BUTTON_TYPE,
        color: window?.theme?.buttonText,
      },
    },
    to_date: {
      "ui:field": "datepicker",
    },
  };
  const fields = {
    datepicker: SingleDatePicker,
  };
  const onSubmitClick = () => {
    const messagesDateTo = new Date(formData.to_date);
    messagesDateTo.setUTCHours(23, 59, 59, 59);
    setPage(1);
    /*     messagesDateTo.setDate(messagesDateTo.getDate() + 1); */
    getReadings({
      ...paramsList,
      page: 1,
      to_date: messagesDateTo.toISOString(),
    });
  };
  useEffect(() => {
    dispatch(setBreadCrumbs("Readings"));
    return () => {
      dispatch(setBreadCrumbs(null));
    };
  }, []);
  useEffect(() => {
    const messagesDateTo = new Date(paramsList.to_date);
    messagesDateTo.setUTCHours(23, 59, 59, 59);
    /*   messagesDateTo.setDate(messagesDateTo.getDate() + 1); */
    getReadings({
      ...paramsList,
      to_date: messagesDateTo.toISOString(),
    });
  }, [page]);

  const onMailClick = (msg) => {
    setMessage(msg);
    setModalMessage(true);
  };

  useEffect(() => {}, [formData]);
  const columns = [
    {
      field: "messageDate",
      headerName: t("readTime"),
      editable: false,
      sortable: false,
      editable: false,
      flex: 1,
      renderCell: (params) => {
        return <>{t("dt", { val: new Date(params.row.messageDate) })}</>;
      },
    },

    {
      field: "strValue",
      headerName: t("value"),
      editable: false,
      sortable: false,
      editable: false,
      flex: 1,
    },
    {
      field: "pod",
      headerName: t("pod"),
      editable: false,
      sortable: false,
      editable: false,
      flex: 1,
    },
    {
      field: "metrological_serial",
      headerName: t("metrological_serial"),
      editable: false,
      sortable: false,
      editable: false,
      flex: 1,
    },
    {
      field: "alarms",
      headerName: t("alarms"),
      editable: false,
      sortable: false,
      editable: false,
      flex: 1,
      renderCell: (params) => {
        if (!params.row.alarms) {
          return <>--</>;
        } else {
          return (
            <Box display={"flex"} flexWrap="wrap" width={"100%"}>
              {params.row.alarms?.map((item, index) => (
                <Chip
                  key={index}
                  style={{
                    backgroundColor: theme.palette.error.main,
                    color: theme.palette.error.contrastText,
                    marginRight: "8px",
                    marginBottom: "8px",
                  }}
                  label={item}
                />
              ))}
            </Box>
          );
        }
      },
    },
    {
      field: "actions",
      headerName: t("actions"),
      type: "number",
      sortable: false,
      editable: false,
      headerAlign: "right",
      flex: 1,
      renderCell: (params) => {
        return (
          <Box
            sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
          >
            <Link to={`/meters/${params.value?.id}`}>
              <VisibilityIcon
                sx={{ float: "right", mt: 1, fill: theme.palette.navIcon }}
              />
            </Link>
            <IconButton onClick={() => onMailClick(params.value.message)}>
              <DraftsIcon sx={{ fill: theme.palette.navIcon }} />
            </IconButton>
          </Box>
        );
      },
    },

    // data[2].attributes.values.values.value.last_reading.datetime_utc
  ];

  useEffect(() => {
    console.log("valix", readings);
  }, [readings]);
  const rows = readings?.map((item, i) => ({
    id: i,
    messageDate: item?.messageDate,
    strValue:
      item?.strValue !== null
        ? `${t("number", {
            val: item.strValue,
          })} ${item?.unit}`
        : "--",
    pod: item?.pod ?? "--",
    metrological_serial: item?.metrological_serial ?? "--",
    alarms: item?.alarms,
    actions: {
      id: item?.deviceId,
      message: item?.values?.values?.value,
    },
  }));
  return (
    <Box sx={{ height: 700 }}>
      <ModalDialog
        open={modalMessage}
        close={() => setModalMessage(false)}
        title={"Message"}
      >
        <Box>
          <Typography variant="subtitle2">
            <pre
              style={{
                overflow: "auto",
                background: "#c0c0c0",

                padding: "9px",
              }}
            >
              {JSON.stringify(message, null, 10)}
            </pre>
          </Typography>
        </Box>
      </ModalDialog>
      <IwdAuthWrapper
        children={
          <Box
            sx={{ mt: 2 }}
            display={"flex"}
            width={"100%"}
            justifyContent={"flex-end"}
          >
            <Button
              onClick={() => navigate("/readings/import")}
              sx={{ float: "right", mt: 2 }}
            >
              {t("import_readings")}
            </Button>
          </Box>
        }
        section={"import_readings_btn"}
      />
      <Form
        schema={schema}
        uiSchema={uiSchema}
        fields={fields}
        formData={formData}
        onSubmit={(values) => {
          onSubmitClick(values.formData);
        }}
        onChange={(changeEvent) => setFormData(changeEvent.formData)}
        validator={validator}
        children={true}
      >
        <Box display={"flex"} justifyContent={"flex-end"}>
          <ExportReadingsButton params={{ to_date: formData?.to_date }} />
          <Button
            sx={{ ml: 2 }}
            variant={window.BUTTON_TYPE}
            onClick={onSubmitClick}
          >
            {t("search")}
          </Button>
        </Box>
      </Form>
      <IwdDataGrid
        columns={columns}
        perPage={perPage}
        setPage={setPage}
        rows={rows ?? []}
        page={page}
        infiniteMode={true}
        sort={false}
        height={600}
        paginationMode={"server"}
        tableName={"all_readings"}
        records={haveRecords}
        recordsFn={setAllReadingsRecors}
      />
    </Box>
  );
};
export default AllLastReadings;
